import { Observable, BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
var FxHotkeyCommunicateService = /** @class */ (function () {
    function FxHotkeyCommunicateService() {
        this._hotkeyConfig = new BehaviorSubject({});
        // private _hotkeyConfig: Subject<any> = new Subject<any>();
        // Observable string streams
        this.hotkeyUpdate$ = this._hotkeyConfig.asObservable();
    }
    /**
     * 向其他组件发送信息
     * @param message 需要发送的信息
     * @returns {Observavle<any>}
     */
    FxHotkeyCommunicateService.prototype.setHotkeyMap = function (hotkeys) {
        this._dangerMsg = hotkeys;
        this._hotkeyConfig.next(hotkeys);
    };
    /**
     * 订阅其他组件发送来的消息
     * @returns {Observalue<any>}
     */
    FxHotkeyCommunicateService.prototype.getHotkeyMap = function () {
        return this._hotkeyConfig.asObservable();
    };
    FxHotkeyCommunicateService.ngInjectableDef = i0.defineInjectable({ factory: function FxHotkeyCommunicateService_Factory() { return new FxHotkeyCommunicateService(); }, token: FxHotkeyCommunicateService, providedIn: "root" });
    return FxHotkeyCommunicateService;
}());
export { FxHotkeyCommunicateService };
